import React from 'react';
import KeepAlive from 'react-activation';
import Home from './pages/homepage';
import Personal from './pages/personal';
import BasicLayout from './layout/index';
import AppLayout from './layout/appLayout';
import MyInfo from './pages/myInfo';
import Setting from './pages/setting';
import ModifyPass from './pages/modifyPassword';
import TSLivePlay from './busi/tscloud/livePlay';
import LivePlay from './busi/saas/play/livePlay';
import LivePlayback from './busi/saas/play/livePlayback';
import ResPlay from './busi/saas/play';
import DeptSubList from './pages/deptSubList';
import sysConfig from './sysConfig';
import Leave from './pages/oa/leave';
import LeaveAuditDetail from './pages/oa/leave/auditDetail';
import KqEmployee from './pages/oa/kqemployee';
import Notice from './pages/oa/notification';
import NoticeDetail from './pages/oa/notification/detail';

import TimeTable from './pages/manage/timeTable';
import Excellence from './pages/manage/excellence';
import Interact from './pages/manage/interact';

import InstructionalSupervision from './pages/supervise';
import RealTimeSupervise from './pages/supervise/instructionalSupervision/realTimeSupervise';
import AfterClassSupervise from './pages/supervise/instructionalSupervision/afterClassSupervise';
import SuperviseQuery from './pages/supervise/instructionalSupervision/superviseQuery';
import AnomalyTracing from './pages/supervise/instructionalSupervision/anomalyTracing';
import SuperviseStatistics from './pages/supervise/instructionalSupervision/superviseStatistics';
import TourVideo from './pages/supervise/onlineCourseTour/tourVideo/TourVideo';
import SupervisePlay from './pages/supervise/instructionalSupervision/supervisePlay';
import Login from './pages/login';

import StudioDetail from './pages/studioDetail';
import StudioResMore from './pages/studioResMore';
import StudioInteractMore from './pages/studioInteractMore';
import SchoolTeacherInfo from '@/pages/prestigiousTeacher';

import PrestigiousSchoolInfo from './pages/prestigiousSchoolInfo';

import NotifyUser from "@/pages/notifyUser";
import notifyInfo from "@/pages/notifyUser/notifyInfo";

import Demonstration from '@/pages/demonstration';

const { preRouteUrl } = sysConfig;

export default [
  {
    path: `${preRouteUrl}/login`,
    component: Login,
  },
  {
    path: `${preRouteUrl}/oa/kqemployee`,
    component: KqEmployee,
  },
  {
    path: `${preRouteUrl}/oa/leave/auditDetail/:leaveId`,
    component: LeaveAuditDetail,
  },
  {
    path: `${preRouteUrl}/oa/leave`,
    component: Leave,
  },
  {
    path: `${preRouteUrl}/oa/notice/detail/:receiveId/:noticeId`,
    component: NoticeDetail,
  },
  {
    path: `${preRouteUrl}/oa/notice`,
    component: Notice,
  },
  {
    path: `${preRouteUrl}/livePlay/:playType/:id`,
    component: LivePlay,
  },
  {
    path: `${preRouteUrl}/livePlayback/:liveType/:id`,
    component: LivePlayback,
  },
  {
    path: `${preRouteUrl}/livePlay/:id`,
    component: TSLivePlay,
  },
  {
    path: `${preRouteUrl}/resPlay/:id`,
    component: ResPlay,
  },
  {
    path: `${preRouteUrl}/prestigiousSchoolInfo/:id`,
    component: PrestigiousSchoolInfo,
  },
  {
    path: `${preRouteUrl}/category/:appCode`,
    component: AppLayout,
  },
  {
    path: `${preRouteUrl}/deptSubList/:deptId`,
    component: DeptSubList,
  },
  {
    path: `${preRouteUrl}/manage/TimeTable`,
    component: () => (
      <KeepAlive>
        <TimeTable></TimeTable>
      </KeepAlive>
    ),
  },
  {
    path: `${preRouteUrl}/manage/interact/:id`,
    component: Interact,
  },
  {
    path: `${preRouteUrl}/manage/excellence/:id`,
    component: Excellence,
  },
  {
    path: `${preRouteUrl}/supervise/supervisePlay/:type/:id`,
    component: SupervisePlay,
  },
  {
    path: `${preRouteUrl}/supervise/instructionalSupervision/realTimeSupervise`,
    component: () => (
      <KeepAlive>
        <RealTimeSupervise />
      </KeepAlive>
    ),
  },
  {
    path: `${preRouteUrl}/supervise/instructionalSupervision/afterClassSupervise`,
    component: () => (
      <KeepAlive>
        <AfterClassSupervise />
      </KeepAlive>
    ),
  },
  {
    path: `${preRouteUrl}/supervise/instructionalSupervision/superviseQuery`,
    component: () => (
      <KeepAlive>
        <SuperviseQuery />
      </KeepAlive>
    ),
  },
  {
    path: `${preRouteUrl}/supervise/instructionalSupervision/anomalyTracing`,
    component: AnomalyTracing,
  },
  {
    path: `${preRouteUrl}/supervise/instructionalSupervision/superviseStatistics`,
    component: SuperviseStatistics,
  },
  {
    path: `${preRouteUrl}/supervise/instructionalSupervision`,
    component: () => (
      <KeepAlive>
        <InstructionalSupervision />
      </KeepAlive>
    ),
  },
  {
    path: `${preRouteUrl}/supervise/tourVideo`,
    component: TourVideo,
  },
  {
    path: `${preRouteUrl}/studioDetail/:id`,
    component: StudioDetail,
  },
  {
    path: `${preRouteUrl}/studio/studioInteractMore`,
    component: StudioInteractMore,
  },
  {
    path: `${preRouteUrl}/studio/resMore`,
    component: StudioResMore,
  },
  {
    path: `${preRouteUrl}/schoolTeacherInfo/:id`,
    component: SchoolTeacherInfo,
  },
  {
    path: `${preRouteUrl}/personal/notifyUser`,
    component: NotifyUser,
  },
  {
    path: `${preRouteUrl}/personal/notifyInfo/:id`,
    component: notifyInfo,
  },
  {
    path: `${preRouteUrl}/demonstration/:tab`,
    component: Demonstration,
  },
  {
    path: '/',
    redirect: `${preRouteUrl}/home`,
    component: BasicLayout,
    routes: [
      {
        path: `${preRouteUrl}/personal/myInfo`,
        component: MyInfo,
      },
      {
        path: `${preRouteUrl}/personal/setting`,
        component: Setting,
      },
      {
        path: `${preRouteUrl}/personal/modifyPassword`,
        component: ModifyPass,
      },
      {
        path: `${preRouteUrl}/home`,
        component: Home,
        exact: true,
      },
      {
        path: `${preRouteUrl}/personal`,
        component: Personal,
      },
    ],
  },
];
